/* ----------------------------------------------------------------------------
 * SELETOR DE QUANTIDADE (custom-variant-picker)
 * ----------------------------------------------------------------------------
 *
 * 🔴 POR QUE ISTO E UM ASSET E NAO UM <script> DENTRO DO SNIPPET.
 *
 * O snippet e usado em dois lugares: na PDP e dentro da gaveta de "Adicionar
 * rapido". A gaveta e montada no clique: o tema busca /products/<handle>,
 * pega o conteudo de <template id="quick-buy-content"> com DOMParser e injeta.
 * Script que nasce dentro de <template> NAO executa quando e injetado, e numa
 * pagina de colecao nao existe PDP pra ter carregado o script antes. Conferido
 * no HTML servido: colecao tinha 4 gavetas e ZERO ocorrencia deste JS.
 *
 * Com o script inline, a gaveta numa colecao mostraria os cards e nenhum
 * clique funcionaria: a cliente escolheria 3 unidades e levaria 1, porque os
 * radios ficam fora do formulario e quem carrega o valor e o input escondido
 * que so este JS escreve.
 *
 * Como asset carregado pelo layout, ele existe em toda pagina, e o
 * MutationObserver liga a gaveta assim que ela e montada.
 * -------------------------------------------------------------------------- */

(function () {
  // Resolve o formulario CERTO — nao o primeiro do documento.
  //
  // Como funciona a ligacao com o carrinho (verificado em theme.js, ProductForm):
  // cada formulario "is=product-form" reabilita o proprio input[name=id] no
  // connectedCallback, e o envio usa new FormData(this), que so recolhe elementos
  // daquele form. Os radios deste seletor ficam FORA do form e sem atributo form=,
  // entao nao entram no FormData de proposito: eles sao so a interface. Quem carrega
  // o valor e o input escondido do formulario. Por isso aqui a gente escreve nele.
  function resolveInput(root) {
    var formId = root.getAttribute('data-form-id');
    var form = (formId && document.getElementById(formId)) ||
               root.closest('form[action*="/cart/add"]');
    return form ? form.querySelector('input[name="id"]') : null;
  }

  function initPicker(root) {
    if (!root || root.dataset.pickerReady === '1') return;

    var options = root.querySelectorAll('[data-variant-option]');
    if (!options.length) return;

    var hiddenInput = resolveInput(root);
    if (!hiddenInput) return;

    // Variantes vem por instancia, num script type=application/json dentro do
    // proprio wrapper. Com PDP e gaveta abertos ao mesmo tempo ha dois seletores na
    // pagina, e uma variavel global faria um ler os dados do outro.
    var variants = [];
    var dataEl = root.querySelector('[data-variant-json]');
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) {} }

    var mainImage = root.closest('.product-info')
      ? document.querySelector('[data-main-product-image]')
      : null;

    function select(option) {
      var variantId = option.getAttribute('data-variant-id');
      if (!variantId) return;

      hiddenInput.value = variantId;
      hiddenInput.disabled = false;

      var featuredImage = option.getAttribute('data-variant-image');
      if (featuredImage && mainImage) mainImage.src = featuredImage;

      options.forEach(function (o) { o.classList.remove('selected'); });
      option.classList.add('selected');

      var radio = option.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;

      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) {
          root.dispatchEvent(new CustomEvent('variant:change', {
            detail: { variant: variants[i] },
            bubbles: true
          }));
          break;
        }
      }
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () { select(this); });
    });

    root.dataset.pickerReady = '1';
    select(root.querySelector('[data-variant-option].selected') || options[0]);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.variant-picker-wrapper').forEach(initPicker);
  }

  // A PDP renderiza junto com a pagina; a gaveta e montada depois, no clique.
  // O DOMContentLoaded sozinho cobria so o primeiro caso.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  if (!window.__variantPickerObserver) {
    window.__variantPickerObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('variant-picker-wrapper')) {
            initPicker(node);
          } else if (node.querySelectorAll) {
            initAll(node);
          }
        });
      });
    });
    window.__variantPickerObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
